/***
 *
 *   HOME LAYOUT
 *   Main website layout
 *
 **********/
import { HomeNav, Footer, useLocation } from 'components/lib';

export function HomeLayout(props) {
	const location = useLocation();

	// the in-page section anchors only exist on the landing page
	const isLanding = location?.pathname === '/';

	return (
		<>
			<main className="home bg-background">
				<HomeNav anchors={isLanding} />
				{<props.children {...props.data} />}
			</main>
			<Footer />
		</>
	);
}
